import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import { ActionControlSize } from '@1js/acui-common';

import { AppSliderStyles } from './AppSlider.Props';

export interface SliderSizedStyles {
  styles?: Partial<AppSliderStyles>;
}

export const getRibbonSliderSizedStyles = memoizeFunction(
  (size: ActionControlSize | undefined, externalStyles: Partial<AppSliderStyles> | undefined): SliderSizedStyles => {
    switch (size) {
      // Add sized styles as needed
      default:
        return { styles: externalStyles };
    }
  }
);
